var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCommonFileText = function SvgCommonFileText(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "2.4rem",
    height: "2.4rem",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "common-file-text") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3,24c-1.241,0-2.25-1.009-2.25-2.25V2.25C0.75,1.009,1.759,0,3,0h15.045c0.592,0,1.149,0.227,1.572,0.639l2.954,2.883 c0.431,0.421,0.679,1.008,0.679,1.611V21.75c0,1.241-1.009,2.25-2.25,2.25H3z M3,1.5c-0.414,0-0.75,0.336-0.75,0.75v19.5 c0,0.414,0.336,0.75,0.75,0.75h18c0.414,0,0.75-0.336,0.75-0.75V5.133c0-0.201-0.083-0.397-0.227-0.537l-2.954-2.883 C18.428,1.576,18.243,1.5,18.046,1.5H3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.045,9c-0.414,0-0.75-0.336-0.75-0.75S5.631,7.5,6.045,7.5h12c0.414,0,0.75,0.336,0.75,0.75S18.458,9,18.045,9H6.045z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.045,13.5c-0.414,0-0.75-0.336-0.75-0.75S5.631,12,6.045,12h12c0.414,0,0.75,0.336,0.75,0.75s-0.336,0.75-0.75,0.75 H6.045z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.045,18c-0.414,0-0.75-0.336-0.75-0.75s0.336-0.75,0.75-0.75h6c0.413,0,0.75,0.336,0.75,0.75S12.458,18,12.045,18H6.045z "
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCommonFileText);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/common-file-text.4c5363d34c2fc17c576b61fe2a74385f.svg";